import { combineReducers } from 'redux';
import HeaderConfig from './HeaderConfig';
import Error from './Error';
export default combineReducers({
  HeaderConfig,
  Error,
});
